import * as z from "zod";

/** Stored series codes, class codes and locations are upper case; the agent may not write them so. */
export const upperCased = z.string().min(1).toUpperCase();
